import { NotificationConfiguration } from '../notification.templates';

export const CR_VOTING_FINISHED: NotificationConfiguration = {
  inapp: `The voting for the circular resolution is finished`,
  email: {
    ctaKey: 'go_to_cr',
  },
};
